<button 
  *ngIf="!linkHref"
  [disabled]="disabled"
  [ngClass]="buttonClasses"
  (click)="onClick($event)"
  [type]="typeAttribute"
>
  <ng-container *ngTemplateOutlet="contentContainer"></ng-container>
</button>

<!-- link button -->
<a
  [attr.href]="linkHref"
  *ngIf="linkHref && !disabled"
  [ngClass]="buttonClasses"
  (click)="onClick($event)"
  attr.role="button"
  [attr.target]="target"
>
  <ng-container *ngTemplateOutlet="contentContainer"></ng-container>
</a>

<!-- link button disabled -->
<a
  *ngIf="linkHref && disabled"
  [ngClass]="[buttonClasses, 'link-disabled']"
  attr.role="button"
>
  <ng-container *ngTemplateOutlet="contentContainer"></ng-container>
</a>

<ng-template #contentContainer>
  <!-- Left positioned icon container -->
  <ng-container *ngIf="iconPosition === irisButtonIconPosition.LEFT">
    <!-- onClick is on all button contents because it prevents click events from
         bubbling up when the iris-button is disabled  -->
    <span class="--icon-position-left" (click)="onClick($event)">
      <ng-container *ngTemplateOutlet="iconContent"></ng-container>
    </span>
  </ng-container>

  <!-- Text content container -->
  <ng-container *ngTemplateOutlet="textContent"></ng-container>

  <!-- Right positioned icon container -->
  <ng-container *ngIf="iconPosition === irisButtonIconPosition.RIGHT">
    <span class="--icon-position-right" (click)="onClick($event)">
      <ng-container *ngTemplateOutlet="iconContent"></ng-container>
    </span>
  </ng-container>
</ng-template>

<!-- Displays the outputted text content -->
<ng-template #textContent>
    <span (click)="onClick($event)">
      <ng-content></ng-content>
    </span>
    {{ ksDocsOnlyButtonText }}
</ng-template>

  <!-- Displays any projected icons -->
<ng-template #iconContent>
  <ng-content select="iris-icon"></ng-content>
</ng-template>